import { publicInstance } from "../config/axios"
import { env } from "../config/env"

export const getEducationalVideo = async (uuid) => {
  const response = await publicInstance.get(`/educational-videos/${uuid}`)
  return response.data
}

// QR-code scan tracking. Answers 204 with no body, and never rejects in a way
// the page should react to — the caller treats it as fire-and-forget.
export const logEducationalVideoEvent = async ({ uuid, ...payload }) => {
  await publicInstance.post(`/educational-videos/${uuid}/events`, payload)
}

// Video playback tracking (loaded/started/percent/step/ended, play/pause/
// waiting state, watched-seconds), batched. Answers 204. Unlike the scan
// event above, the caller does look at failures: the queue retries temporary
// ones and drops the rest (see usePlayerEventQueue).
export const logEducationalVideoPlayerEvents = async ({ uuid, events }) => {
  await publicInstance.post(`/educational-videos/${uuid}/player-events/batch`, {
    events,
  })
}

// The same endpoint as an absolute URL, for navigator.sendBeacon (and its
// fetch keepalive fallback), which can't go through axios.
export const getPlayerEventsBatchUrl = (uuid) =>
  `${env.REACT_APP_BASE_URL}/educational-videos/${uuid}/player-events/batch`
